import {useState, useRef} from "react";
import ReactQuill, { Quill } from "react-quill";
import * as Emoji from "quill-emoji";
import "quill-mention";
import "react-quill/dist/quill.snow.css";
import "quill-emoji/dist/quill-emoji.css";
import linkicon from './../../../../assets/home/newsfeed/linkiocn.png'
import mentionicon from './../../../../assets/home/newsfeed/mentionicon.png'
import './reactquill-editor.scss';


import { markdownToHtml, htmlToMarkdown } from "./parser";

Quill.register("modules/emoji", Emoji);

//Add custom Icon for toolbar link

var icons = Quill.import('ui/icons');
icons['image'] = `<img src=${linkicon} />`;
icons['link'] = `<img src=${mentionicon} />`;


const atValues = [
  { id: 1, value: "Naveed" },
  { id: 2, value: "Noman" },
  { id: 3, value: "Arslan" },
  { id: 4, value: "john" },
  { id: 5, value: "michel" },
  { id: 6, value: "jos" },
  { id: 7, value: "ben" },

];
const hashValues = [
  { id: 3, value: "Fredrik Sundqvist 2" },
  { id: 4, value: "Patrik Sjölin 2" }
];

//MENTION CONFIGURATION

const mentionModuleConfig = {
  allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
  mentionDenotationChars: ["@", "#"],
  source: function (searchTerm, renderList, mentionChar) {
    let values;

    if (mentionChar === "@") {
      values = atValues;
    } else {
      values = hashValues;
    }

    if (searchTerm.length === 0) {
      renderList(values, searchTerm);
    } else {
      const matches = [];
      for (let i = 0; i < values.length; i++)
        if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase()))
          matches.push(values[i]);
      renderList(matches, searchTerm);
    }
  }
};



//TOOLBAR CONFIGURATION




function EditorComponent(props) {




  const {onEditorContentChanged, placeholder, editPost, counter} = props
  const [value, setValue] = useState(markdownToHtml(null));
  const[ok, setOk] =  useState(true)
  const reactQuillRef = useRef<ReactQuill>(null);

  const broadcastModules = {
    mention: mentionModuleConfig,
      toolbar: [
      // [{ header: [1, 2, 3, false] }],
      ["image"],
      ['emoji'],
      ["link"],
  
  ],
  "emoji-toolbar": true,
  };
  const voteModules = {
    mention: mentionModuleConfig,
      toolbar: [
      // [{ header: [1, 2, 3, false] }],
      // ["image"],
      ['emoji'],
      ["link"],
  
  ],
  "emoji-toolbar": true,
  };

  console.log(editPost)
  const onChange = (content) => {
    setValue(content);
    // console.log(value)

    if (onEditorContentChanged) {
      onEditorContentChanged({html: content, markdown: htmlToMarkdown(content) });
    }
  };

  return <ReactQuill defaultValue="lol"  placeholder={placeholder} value={value} onChange={onChange} modules={counter==1? broadcastModules:(counter==2 || counter==3)? voteModules : null} />;
}
 
export default EditorComponent;
